import { useState } from 'react';

/**
 * The last non-null value: keeps a dialog's content in place while its
 * close animation runs after the value was reset to null.
 */
export function useRetainedValue<T>(value: T | null): T | null {
  const [retained, setRetained] = useState(value);
  if (value !== null && value !== retained) setRetained(value);
  return value ?? retained;
}
